import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    className="border-t border-white/5 px-6 pb-28 pt-10 md:px-12 md:py-10 lg:px-24"
    data-testid="site-footer"
  >
    <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
      <span className="font-jetbrains text-sm tracking-[0.35em] text-[#F4F4F0]">AFANASIEV</span>
      <p className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#525252]">
        © 2026 · Дизайн Про · Стрижка по лицу, а не наугад
      </p>
      <div className="flex items-center gap-5 font-jetbrains text-[10px] uppercase tracking-[0.2em] text-[#525252]">
        <Link
          to="/privacy"
          className="transition-colors duration-500 hover:text-[#C2A878]"
          data-testid="footer-privacy-link"
        >
          Конфиденциальность
        </Link>
        <Link
          to="/offer"
          className="transition-colors duration-500 hover:text-[#C2A878]"
          data-testid="footer-offer-link"
        >
          Оферта
        </Link>
        <Link
          to="/requisites"
          className="transition-colors duration-500 hover:text-[#C2A878]"
          data-testid="footer-requisites-link"
        >
          Реквизиты
        </Link>
      </div>
      <Link
        to="/preview"
        className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#525252] transition-colors duration-500 hover:text-[#C2A878]"
        data-testid="footer-preview-link"
      >
        Открыть приложение
      </Link>
      <Link
        to="/admin"
        className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#525252] transition-colors duration-500 hover:text-[#C2A878]"
        data-testid="footer-admin-link"
      >
        Вход для владельца
      </Link>
    </div>
  </footer>
);
